// The portal's alert sound and loudness, both chosen under Edit Profile →
// Notifications and stored inside the user's notificationPreferences.

export const WEB_ALERT_SOUNDS = ['chime', 'bell', 'alarm', 'siren', 'pager'];
export const DEFAULT_WEB_ALERT_VOLUME = 60; // percent; full volume startled people

const storedPrefs = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null')?.notificationPreferences || {};
  } catch {
    return {};
  }
};

/** URL of the chosen sound, or null when the user picked "None". */
export const getWebAlertSoundUrl = () => {
  const sound = storedPrefs().webAlertSound;
  if (sound === 'none') return null;
  if (WEB_ALERT_SOUNDS.includes(sound)) return `/sounds/alert_${sound}.wav`;
  return '/notification-sound.mp3'; // legacy default
};

/** 0–1 for Audio.volume / a gain node. */
export const getWebAlertVolume = () => {
  const raw = Number(storedPrefs().webAlertVolume);
  const percent = Number.isFinite(raw) ? Math.min(100, Math.max(0, raw)) : DEFAULT_WEB_ALERT_VOLUME;
  return percent / 100;
};
